import React from 'react';
import { useReactToPrint } from 'react-to-print';
type Props = {
  customerContent: () => React.ReactInstance | null;
  staffContent: () => React.ReactInstance | null;
  ownerContent: () => React.ReactInstance | null;
};
const usePrintDoubleReceiptWithStaff = ({ customerContent, staffContent, ownerContent }: Props) => {

  const doPrintStaffReceipt = useReactToPrint({
    content: () => staffContent(),
  });

  const doPrintCustomerReceipt = useReactToPrint({
    content: () => customerContent(),
    onAfterPrint: () => doPrintStaffReceipt(),
  });

  const doPrintDoubleReceipt = useReactToPrint({
    content: () => ownerContent(),
    onAfterPrint: () => doPrintCustomerReceipt(),
  });


  return doPrintDoubleReceipt;
};

export default usePrintDoubleReceiptWithStaff;
